<template>
  <page-outline :title="pageTitle">
    <template slot="primaryActions">
      <app-button :is-back-button="true" :return-url="returnUrl" variant="secondary" :outline="true" size="md"></app-button>
    </template>
    
    <template slot="pageContent">
      <b-container fluid>
        <spinner v-if="activateSpinner"></spinner>
        <biconus-form :mode="mode" :readonly="!isEditable" v-model="config" v-else></biconus-form>
      </b-container>
    </template>
    
    <template slot="bottomActions">
      <app-button
        v-if="isEditable && formType !== 'add'"
        :text="$t('common.cncl')"
        variant="secondary"
        :outline="true"
        size="md"
        custom-class="mr-3"
        :aria-label="$t('common.cncl') + ' ' + $t('Webheader.bic_onus_edit')"
        @click="switchMode('details')"
      />
      <app-button
        v-if="!isEditable && formType !== 'add'"
        :text="$t('administration.edit')"
        icon="fa-light fa-pencil"
        variant="primary"
        size="md"
        custom-class="mr-2"
        :aria-label="$t('administration.edit') + ' ' + $t('common.bic.bic_onus')"
        @click="switchMode('edit')"
      />
      <app-button
        v-if="!isEditable && formType !== 'add'"
        :text="$t('rights.delete')"
        icon="fa-light fa-trash"
        variant="danger"
        size="md"
        custom-class="ml-2"
        :aria-label="$t('rights.delete') + ' ' + $t('common.bic.bic_onus')"
        @click="deleteBICOnus"
      />
      <app-button
        v-if="isEditable && formType !== 'add'"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="success"
        size="md"
        :aria-label="$t('common.sve') + ' ' + $t('common.bic.bic_onus')"
        @click="editBICOnus"
      />
      <app-button
        v-if="mode === 'add'"
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="success"
        size="md"
        :aria-label="$t('common.sve') + ' ' + $t('common.bic.bic_onus')"
        @click="addBICOnus"
      />
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import Spinner from '@/components/common/spinner.vue'
import AppButton from '@/components/common/AppButton.vue'
import {loadPage} from '@/helpers/routing'
import BICOnusForm from "@/pages/biconus/BICOnusForm.vue";

export default {
  Name: "BICDetails",
  components: {
    'biconus-form': BICOnusForm,
    'page-outline': PageOutline,
    'spinner': Spinner,
    AppButton
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.bic_onus_edit')
        case 'details':
          return this.$t('Webheader.bic_onus_details')
        case 'add':
        default:
          return this.$t('Webheader.bic_onus_add')
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      alerts: '',
      returnUrl: '',
      currentBICOnus: {},
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.returnUrl = '/biconus/'

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getBICOnus()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addBICOnus () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        BIC: this.config.BIC
      }
      this.$engine.firstOn().bic.bic.createOnus(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.bic.bic_onus_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/biconus/'})
      })
      .catch(e => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "BIC Exist") {
              that.okMessageBox(that.$t('common.bic.bic_exist'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
        }
      })
    },
    deleteBICOnus () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.bic.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdBICOnus: that.id
              }
              that.$engine.firstOn().bic.bic.deleteOnus(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.bic.bic_onus_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: '/biconus/'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.bic.bic_onus_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editBICOnus () {

      if (this.formHasError()) {
        return
      }

      let that = this
      let params = {
        BIC: this.config.BIC,
        IdBICOnus: this.id
      }
      this.$engine.firstOn().bic.bic.editOnus(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.bic.bic_onus_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/biconus/'})
      })
      .catch(e => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "BIC Exist") {
              that.okMessageBox(that.$t('common.bic.bic_exist'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
        }
      })
    },
    fillFields () {
      this.config = this.currentBICOnus
      this.originalConfig = this.currentBICOnus
      this.activateSpinner = false
    },
    formHasError () {

      const bicRegex = /^[A-Za-z]{6,6}[A-Za-z2-9][A-NP-Za-np-z0-9]([A-Za-z0-9]{3,3}){0,1}?$/

      if (this.config.BIC === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.bic.BIC_missing'))
        return true
      }

      if (!bicRegex.test(this.config.BIC)) {
        this.okMessageBox(this.$t('common.bic.BIC_invalid'));
        return true;
      }

      return false
    },
    getBICOnus () {
      this.$engine.firstOn().bic.bic.fetchOnus({id: this.id})
      .then(resp => {
        let that = this
        let bicList = {}

        bicList = resp.data.BICOnus

        that.updateBic(bicList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateBic(BICList){
      const selectedAlerts = BICList.find(alerts => alerts.IdBICOnus === this.id)
      this.currentBICOnus = selectedAlerts
      this.fillFields()
    }
  }
}
</script>

<style scoped>
/* Styles d'accessibilité améliorés pour le focus avec couleur DealPrudence */
.btn:focus,
.b-button:focus,
button:focus,
input:focus,
select:focus,
textarea:focus,
a:focus,
[tabindex]:focus {
  box-shadow: 0 0 0 0.25rem rgba(17, 176, 175, 0.25) !important;
}

/* Support minimal pour les petits écrans */
@media (max-width: 576px) {
  .btn {
    min-height: 44px !important;
  }
}
</style>
